(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var SECTION = 'cart-drawer';
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.dataset.init) return;
    drawer.dataset.init = '1';
    var content = drawer.querySelector('[data-cart-content]');

    function open() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }

    function updateCounts(n) {
      document.querySelectorAll('.header__cart-count').forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', n === 0); });
      var dc = drawer.querySelector('[data-drawer-count]'); if (dc) dc.textContent = n;
    }
    function render(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nc = doc.querySelector('[data-cart-content]');
      if (nc && content) content.innerHTML = nc.innerHTML;
      var dc = doc.querySelector('[data-drawer-count]');
      if (dc) updateCounts(parseInt(dc.textContent, 10) || 0);
    }
    function renderFromSections(sections) { if (sections && sections[SECTION]) render(sections[SECTION]); }

    function change(key, qty) {
      drawer.classList.add('is-loading');
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: SECTION, sections_url: location.pathname })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        renderFromSections(cart.sections);
        updateCounts(cart.item_count);
        drawer.classList.remove('is-loading');
      }).catch(function () { drawer.classList.remove('is-loading'); });
    }

    // Open from header cart icon; close from overlay / close buttons
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-toggle], .header__cart')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

    // Quantity / remove (delegated within the drawer)
    drawer.addEventListener('click', function (e) {
      var line = e.target.closest('[data-key]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var valEl = line.querySelector('[data-cart-qty]');
      var v = valEl ? (parseInt(valEl.textContent, 10) || 1) : 1;
      if (e.target.closest('[data-cart-plus]')) change(key, v + 1);
      else if (e.target.closest('[data-cart-minus]')) change(key, Math.max(0, v - 1));
      else if (e.target.closest('[data-cart-remove]')) change(key, 0);
    });

    // Open + refresh when an item is added elsewhere (product page)
    document.addEventListener('cart:added', function (e) {
      if (e.detail && e.detail.sections) renderFromSections(e.detail.sections);
      if (e.detail && e.detail.item_count != null) updateCounts(e.detail.item_count);
      open();
    });

    window.CartDrawer = { open: open, close: close };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var page = document.querySelector('[data-cart-page]');
    if (!page || page.dataset.init) return;
    page.dataset.init = '1';
    var sectionId = page.getAttribute('data-section-id');
    var content = page.querySelector('[data-cart-content]');

    function updateCounts(n) {
      document.querySelectorAll('.header__cart-count').forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', n === 0); });
      var dc = document.querySelector('[data-drawer-count]'); if (dc) dc.textContent = n;
    }
    function render(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nc = doc.querySelector('[data-cart-content]');
      if (nc && content) content.innerHTML = nc.innerHTML;
    }
    function change(key, qty) {
      page.classList.add('is-loading');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: sectionId, sections_url: '/cart' })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        if (cart.sections && cart.sections[sectionId]) render(cart.sections[sectionId]);
        updateCounts(cart.item_count);
        page.classList.remove('is-loading');
      }).catch(function () { page.classList.remove('is-loading'); location.reload(); });
    }
    page.addEventListener('click', function (e) {
      var line = e.target.closest('[data-key]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var valEl = line.querySelector('[data-cart-qty]');
      var v = valEl ? (parseInt(valEl.textContent, 10) || 1) : 1;
      if (e.target.closest('[data-cart-plus]')) change(key, v + 1);
      else if (e.target.closest('[data-cart-minus]')) change(key, Math.max(0, v - 1));
      else if (e.target.closest('[data-cart-remove]')) change(key, 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-modals"]) return;
  try {
    
  (function () {
    var modals = document.querySelectorAll('[data-modal]');
    if (!modals.length || document.body.dataset.modalsInit) return;
    document.body.dataset.modalsInit = '1';

    var ROW_H = 36;

    // ---- availability parsing (each location carries data-avail="Mon-Fri 11:00-20:00 ; Sat-Sun 15:00-18:00") ----
    var DAY = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };
    function parseDays(spec) {
      spec = (spec || '').toLowerCase().replace(/[–—]/g, '-').replace(/\s+/g, '');
      if (!spec || spec === 'everyday' || spec === 'daily' || spec === 'all') return [0, 1, 2, 3, 4, 5, 6];
      var out = [], key = function (t) { return DAY[t.slice(0, 3)]; };
      spec.split(',').forEach(function (part) {
        var r = part.split('-'), d;
        if (r.length === 2 && key(r[0]) !== undefined && key(r[1]) !== undefined) {
          var a = key(r[0]), b = key(r[1]);
          if (a <= b) { for (d = a; d <= b; d++) out.push(d); }
          else { for (d = a; d <= 6; d++) out.push(d); for (d = 0; d <= b; d++) out.push(d); }
        } else if (key(part) !== undefined) { out.push(key(part)); }
      });
      return out;
    }
    function parseAvail(str) {
      var rules = [];
      (str || '').split(';').forEach(function (seg) {
        var m = seg.trim().match(/^(.+?)\s+(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})$/);
        if (m) rules.push({ days: parseDays(m[1]), start: +m[2] + (+m[3]) / 60, end: +m[4] + (+m[5]) / 60 });
      });
      return rules;
    }
    function fmtHour(h) { var ap = (h < 12 || h === 24) ? 'AM' : 'PM', d = h % 12; if (d === 0) d = 12; return d + ':00 ' + ap; }
    function slotsFromRules(rules) {
      var set = {};
      rules.forEach(function (r) { for (var h = Math.ceil(r.start - 1e-9); h <= Math.floor(r.end + 1e-9); h++) set[h] = 1; });
      return Object.keys(set).map(Number).sort(function (x, y) { return x - y; }).map(fmtHour);
    }

    // ---- tap-to-open dropdown pickers ----
    var pickers = [];
    function closePickers(except) { for (var i = 0; i < pickers.length; i++) { if (pickers[i].el !== except) pickers[i].close(); } }
    function clearMissing(input) {
      var field = input && input.closest('.bform__field');
      if (!field) return;
      field.classList.remove('is-missing');
      var msg = field.querySelector('[data-req-msg]');
      if (msg) msg.hidden = true;
    }

    // Plain option list — the whole list is on screen, one tap picks a value.
    function buildList(root, onChange) {
      var trigger = root.querySelector('[data-picker-trigger]');
      var panel = root.querySelector('[data-picker-panel]');
      var current = root.querySelector('[data-picker-current]');
      var input = document.querySelector('[data-picker-input="' + root.getAttribute('data-picker') + '"]');
      var placeholder = root.getAttribute('data-picker-placeholder') || '';
      var items = Array.prototype.slice.call(root.querySelectorAll('.picker__option'));
      if (!items.length) return null;
      var index = -1;  // -1 = nothing chosen yet ("Please select")

      function paint() {
        for (var i = 0; i < items.length; i++) {
          var on = i === index;
          items[i].classList.toggle('is-selected', on);
          items[i].setAttribute('aria-selected', on ? 'true' : 'false');
        }
        root.classList.toggle('is-pending', index < 0);
        var val = index < 0 ? '' : items[index].getAttribute('data-value');
        if (current) current.textContent = index < 0 ? placeholder : val;
        if (input) input.value = val;
      }
      function choose(i) {
        var changed = i !== index;
        index = i;
        paint();
        clearMissing(input);
        close();
        if (trigger) { try { trigger.focus({ preventScroll: true }); } catch (e) {} }
        if (changed && onChange) onChange();
      }
      function openPanel() {
        closePickers(root);
        root.classList.add('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        if (panel) panel.hidden = false;
        var target = items[index < 0 ? 0 : index];
        requestAnimationFrame(function () {
          if (panel) { try { panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {} }
          try { target.focus({ preventScroll: true }); } catch (e) {}
        });
      }
      function close() {
        if (!root.classList.contains('is-open')) return;
        root.classList.remove('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      }
      if (trigger) {
        trigger.addEventListener('click', function (e) { e.stopPropagation(); if (root.classList.contains('is-open')) close(); else openPanel(); });
        trigger.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); openPanel(); } });
      }
      items.forEach(function (it, i) {
        it.addEventListener('click', function (e) { e.stopPropagation(); choose(i); });
        it.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            var to = e.key === 'ArrowDown' ? Math.min(items.length - 1, i + 1) : Math.max(0, i - 1);
            try { items[to].focus(); } catch (err) {}
          } else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(i); }
          else if (e.key === 'Escape' || e.key === 'Tab') { close(); if (trigger) { try { trigger.focus(); } catch (err) {} } }
        });
      });
      var initial = input ? input.value : '';
      for (var n = 0; n < items.length; n++) { if (items[n].getAttribute('data-value') === initial) { index = n; break; } }
      if (!placeholder && index < 0) index = 0;
      paint();
      var ctrl = {
        el: root,
        close: close,
        refresh: paint,
        value: function () { return index < 0 ? '' : items[index].getAttribute('data-value'); },
        active: function () { return index < 0 ? null : items[index]; },
        isPending: function () { return index < 0; }
      };
      pickers.push(ctrl);
      return ctrl;
    }

    // iOS-style scroll drum, for the long list of hours.
    function buildWheel(root, onChange) {
      var scroll = root.querySelector('[data-wheel-scroll]');
      var list = root.querySelector('.wheel__list');
      var trigger = root.querySelector('[data-picker-trigger]');
      var panel = root.querySelector('[data-picker-panel]');
      var current = root.querySelector('[data-picker-current]');
      var input = document.querySelector('[data-picker-input="' + root.getAttribute('data-picker') + '"]');
      if (!scroll || !list) return null;
      // Placeholder mode: the wheel starts unchosen ("Please select", empty
      // input) and the customer must actively pick — required-field UX.
      var placeholder = root.getAttribute('data-picker-placeholder');
      var pending = false;
      var items = [], index = 0, raf;
      function paint(i) { for (var k = 0; k < items.length; k++) items[k].classList.toggle('is-active', k === i); }
      function showCurrent() { if (current && items[index]) current.textContent = items[index].getAttribute('data-value'); }
      function enterPending() {
        pending = true; index = 0;
        root.classList.add('is-pending');
        if (input) input.value = '';
        paint(-1);
        if (current) current.textContent = placeholder;
      }
      function selectValue(val) {
        index = 0;
        for (var i = 0; i < items.length; i++) { if (items[i].getAttribute('data-value') === val) { index = i; break; } }
        if (input && items[index]) input.value = items[index].getAttribute('data-value');
        paint(index); showCurrent();
      }
      function wire() {
        items = Array.prototype.slice.call(list.querySelectorAll('.wheel__item'));
        // Tapping an item picks it and closes the dropdown.
        items.forEach(function (it, i) { it.onclick = function () { scroll.scrollTop = i * ROW_H; commit(); close(); }; });
      }
      function commit() {
        // Programmatic scrolls while the panel is closed (setItems rebuilds)
        // must not count as the customer choosing.
        if (panel && panel.hidden && pending) return;
        var i = Math.round(scroll.scrollTop / ROW_H);
        if (i < 0) { i = 0; } if (i > items.length - 1) { i = items.length - 1; }
        var changed = i !== index || pending;
        pending = false; root.classList.remove('is-pending');
        index = i; paint(i);
        if (input && items[i]) {
          input.value = items[i].getAttribute('data-value');
          clearMissing(input);
        }
        showCurrent();
        if (changed && onChange) onChange();
      }
      function openPanel() {
        closePickers(root);
        root.classList.add('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        if (panel) panel.hidden = false;
        requestAnimationFrame(function () { scroll.scrollTop = index * ROW_H; paint(index); try { scroll.focus({ preventScroll: true }); } catch (e) {} });
      }
      function close() {
        if (!root.classList.contains('is-open')) return;
        root.classList.remove('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      }
      if (trigger) trigger.addEventListener('click', function (e) { e.stopPropagation(); if (root.classList.contains('is-open')) close(); else openPanel(); });
      scroll.addEventListener('scroll', function () { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(commit); });
      scroll.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); scroll.scrollTo({ top: Math.min(items.length - 1, index + 1) * ROW_H, behavior: 'smooth' }); }
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); scroll.scrollTo({ top: Math.max(0, index - 1) * ROW_H, behavior: 'smooth' }); }
        else if (e.key === 'Enter' || e.key === 'Escape') { e.preventDefault(); close(); if (trigger) trigger.focus(); }
      });
      wire();
      if (placeholder && input && input.value === '') { enterPending(); }
      else { selectValue(input ? input.value : (items[0] && items[0].getAttribute('data-value'))); }
      var ctrl = {
        el: root,
        close: close,
        refresh: function () { paint(pending ? -1 : index); if (!pending) showCurrent(); },
        value: function () { return pending ? '' : (items[index] ? items[index].getAttribute('data-value') : ''); },
        active: function () { return pending ? null : items[index]; },
        isPending: function () { return pending; },
        setItems: function (arr, def) {
          var html = '';
          for (var i = 0; i < arr.length; i++) { var v = String(arr[i]); html += '<li class="wheel__item" data-value="' + v.replace(/"/g, '&quot;') + '" role="option">' + v + '</li>'; }
          list.innerHTML = html; wire();
          var keep = input ? input.value : '';
          if (placeholder && (keep === '' || arr.indexOf(keep) < 0)) {
            // Nothing chosen yet (or the chosen slot no longer exists on the
            // new day) — stay/return to the "Please select" state.
            enterPending(); scroll.scrollTop = 0;
          } else if (placeholder) {
            selectValue(keep); scroll.scrollTop = index * ROW_H;
          } else {
            selectValue(def != null ? def : (arr[0] || '')); scroll.scrollTop = index * ROW_H; paint(index); showCurrent();
          }
        }
      };
      pickers.push(ctrl);
      return ctrl;
    }

    // ---- booking: city availability drives the date + time pickers ----
    var locPicker, timeWheel;
    var dateInput = document.getElementById('bk-date');
    var dateNote = document.querySelector('[data-book-date-note]');
    function cityRules() { var it = locPicker && locPicker.active(); return parseAvail(it ? it.getAttribute('data-avail') : ''); }
    function cityName() { var v = locPicker ? locPicker.value() : ''; return v.replace(/\s*-\s*(showroom|pickup point).*/i, '').trim() || 'This location'; }
    function dayRules(rules, wd) { return rules.filter(function (r) { return r.days.indexOf(wd) >= 0; }); }
    function rebuildTimes() {
      if (!timeWheel) return;
      var rules = cityRules(), slots = [];
      if (!rules.length) { for (var h = 8; h <= 24; h++) slots.push(fmtHour(h)); }
      else if (dateInput && dateInput.value) {
        var p = dateInput.value.split('-'); slots = slotsFromRules(dayRules(rules, new Date(+p[0], +p[1] - 1, +p[2]).getDay()));
      } else { slots = slotsFromRules(rules); }
      timeWheel.setItems(["I'm flexible"].concat(slots), "I'm flexible");
    }
    function validateDate() {
      if (!dateInput) return;
      if (!dateInput.value) { if (dateNote) dateNote.textContent = ''; rebuildTimes(); return; }
      var rules = cityRules(), p = dateInput.value.split('-'), wd = new Date(+p[0], +p[1] - 1, +p[2]).getDay();
      if (rules.length && dayRules(rules, wd).length === 0) {
        if (dateNote) dateNote.textContent = cityName() + " isn't open that day — please pick another date.";
        dateInput.value = '';
      } else if (dateNote) { dateNote.textContent = ''; }
      rebuildTimes();
    }

    var locRoot = document.querySelector('[data-picker="loc"]');
    var timeRoot = document.querySelector('[data-picker="time"]');
    if (locRoot) locPicker = buildList(locRoot, validateDate);
    if (timeRoot) timeWheel = buildWheel(timeRoot, null);
    if (dateInput) dateInput.addEventListener('change', validateDate);
    rebuildTimes();

    // Location + time are required: block submit while either picker is still
    // on "Please select" and show the inline hint. Runs before Shopify's
    // captcha handler; native validation covers name/email/date first.
    var bookingForm = document.getElementById('BookingForm');
    if (bookingForm) {
      bookingForm.addEventListener('submit', function (e) {
        var firstBad = null;
        ['loc', 'time'].forEach(function (key) {
          var inp = bookingForm.querySelector('[data-picker-input="' + key + '"]');
          if (!inp) return;
          var field = inp.closest('.bform__field');
          var msg = field && field.querySelector('[data-req-msg]');
          var missing = inp.value === '';
          if (field) field.classList.toggle('is-missing', missing);
          if (msg) msg.hidden = !missing;
          if (missing && !firstBad) firstBad = field || inp;
        });
        if (firstBad) {
          e.preventDefault();
          e.stopImmediatePropagation();
          firstBad.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      });
    }

    function open(name) {
      modals.forEach(function (m) {
        var on = m.getAttribute('data-modal') === name;
        m.classList.toggle('is-open', on);
        m.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      document.documentElement.style.overflow = 'hidden';
      if (name === 'book') { requestAnimationFrame(function () { pickers.forEach(function (p) { p.refresh(); }); }); }
      var active = document.querySelector('[data-modal="' + name + '"].is-open');
      if (active) { var f = active.querySelector('input:not([type=hidden]), textarea, button'); if (f) try { f.focus(); } catch (e) {} }
    }
    function closeAll() {
      closePickers(null);
      modals.forEach(function (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); });
      document.documentElement.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      var book = e.target.closest('a[href$="#book"], [data-open-booking]');
      if (book) { e.preventDefault(); open('book'); return; }
      var contact = e.target.closest('a[href$="#contact"], [data-open-contact]');
      if (contact) { e.preventDefault(); open('contact'); return; }
      if (e.target.closest('[data-modal-close]')) { e.preventDefault(); closeAll(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openTips = document.querySelectorAll('.bform__help.is-open');
      for (var i = 0; i < openTips.length; i++) openTips[i].classList.remove('is-open');
      var pickerOpen = false;
      for (var j = 0; j < pickers.length; j++) { if (pickers[j].el && pickers[j].el.classList.contains('is-open')) pickerOpen = true; }
      if (pickerOpen) { closePickers(null); return; }  // Esc closes an open dropdown first
      closeAll();
    });

    // Tapping anywhere outside an open dropdown closes it.
    document.addEventListener('click', function (e) { if (!e.target.closest('.picker')) closePickers(null); });

    // Help (?) tooltips — hover is CSS; this adds tap/click toggle on touch.
    document.addEventListener('click', function (e) {
      var help = e.target.closest('[data-help]');
      var openTips = document.querySelectorAll('.bform__help.is-open');
      for (var i = 0; i < openTips.length; i++) { if (openTips[i] !== help) openTips[i].classList.remove('is-open'); }
      if (help) help.classList.toggle('is-open');
    });

    // Tap-to-copy rows (e.g. WeChat ID)
    document.addEventListener('click', function (e) {
      var c = e.target.closest('[data-copy]');
      if (!c) return;
      var val = c.getAttribute('data-copy');
      var out = c.querySelector('[data-copy-val]');
      function done() { if (out) { var prev = out.textContent; out.textContent = 'Copied ✓'; setTimeout(function () { out.textContent = prev; }, 1400); } }
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(val).then(done).catch(done); } else { done(); }
    });

    // Open on initial load if URL hash matches (e.g. after a non-JS contact submit)
    if (location.hash === '#book') open('book');
    if (location.hash === '#contact') open('contact');

    // The booking form posts normally so Shopify's spam protection (reCAPTCHA) can attach
    // its token. After Shopify redirects back, re-open the modal to show the result.
    var bookModal = document.querySelector('[data-modal="book"]');
    if (bookModal && (bookModal.querySelector('.modal__done') || bookModal.querySelector('.bform__error'))) {
      open('book');
    }

    // Stamp hidden [data-attrib-input] fields (booking + contact forms) with first-touch
    // UTM / gclid / landing / referrer, so the notification email shows where the
    // enquiry came from (paid Google Ads vs organic). First touch is kept in
    // sessionStorage because the enquiry usually happens pages after landing.
    try {
      var qs = new URLSearchParams(location.search);
      var attrib = null;
      try { attrib = JSON.parse(sessionStorage.getItem('ac_attrib') || 'null'); } catch (err) { attrib = null; }
      if (!attrib) {
        attrib = {
          landing: location.pathname + location.search,
          ref: document.referrer || '',
          us: qs.get('utm_source') || '', um: qs.get('utm_medium') || '',
          uc: qs.get('utm_campaign') || '', un: qs.get('utm_content') || '', ut: qs.get('utm_term') || '',
          gclid: qs.get('gclid') || ''
        };
        try { sessionStorage.setItem('ac_attrib', JSON.stringify(attrib)); } catch (err) {}
      }
      var gclCookie = document.cookie.match(/(?:^|; )_gcl_aw=([^;]*)/);
      var gclid = attrib.gclid || (gclCookie ? decodeURIComponent(gclCookie[1]).split('.').slice(2).join('.') : '');
      var bits = [];
      if (attrib.us || attrib.um) bits.push('utm=' + [attrib.us, attrib.um, attrib.uc, attrib.un, attrib.ut].filter(Boolean).join('/'));
      if (gclid) bits.push('gclid=' + gclid);
      if (attrib.landing) bits.push('landing=' + attrib.landing);
      if (attrib.ref) bits.push('ref=' + attrib.ref);
      var attribVal = bits.length ? bits.join(' | ') : 'no-attribution-data';
      var attribFields = document.querySelectorAll('[data-attrib-input]');
      for (var ai = 0; ai < attribFields.length; ai++) attribFields[ai].value = attribVal;
    } catch (err) { /* attribution must never break the modals */ }

    // Google Ads lead conversions — all four are SECONDARY actions ("AC Lead - *" in
    // the Ads account), so they never touch the main Conversions column or bidding.
    // Form conversions fire on the post-submit success page (?contact_posted=true),
    // where the URL hash tells the booking modal (#BookingForm) apart from the
    // contact-page form (#ContactPageForm); with no hash, a page without the
    // contact-page success block can only be a booking submit. mailto:/tel: fire on
    // click. Per-form sessionStorage keys stop success-page reloads from double
    // counting; each new form submission clears its own key first, so a later
    // legitimate booking/contact in the same tab is still counted.
    try {
      var CONV = {
        book: 'DBGGCP-27eUcEIvfxPFD',
        contact: 'yv10CIK37eUcEIvfxPFD',
        email: '_iTLCIW37eUcEIvfxPFD',
        phone: 'XspUCIi37eUcEIvfxPFD'
      };
      var sendConv = function (label, kind) {
        /* belt & braces: make sure the real gtag.js is (being) loaded — the
           stub queues the event in dataLayer and it is replayed on arrival,
           so a conversion can never outrun the lazy loader */
        if (typeof window.acLoadGtag === 'function') window.acLoadGtag();
        if (typeof gtag === 'function') gtag('event', 'conversion', { send_to: 'AW-18223280011/' + label });
      };
      var sessionGet = function (key) {
        try { return sessionStorage.getItem(key); } catch (err) { return null; }
      };
      var sessionSet = function (key) {
        try { sessionStorage.setItem(key, '1'); } catch (err) {}
      };
      var sessionRemove = function (key) {
        try { sessionStorage.removeItem(key); } catch (err) {}
      };
      document.addEventListener('submit', function (e) {
        var formId = e.target && e.target.id;
        if (formId !== 'BookingForm' && formId !== 'ContactPageForm') return;
        if (e.defaultPrevented) return;
        sessionRemove(formId === 'BookingForm' ? 'ac_conv_sent_book' : 'ac_conv_sent_contact');
      });
      if (location.search.indexOf('contact_posted=true') !== -1) {
        var isBook;
        if (location.hash === '#BookingForm') isBook = true;
        else if (location.hash === '#ContactPageForm') isBook = false;
        else isBook = !document.querySelector('.cform__done');
        var convKey = isBook ? 'ac_conv_sent_book' : 'ac_conv_sent_contact';
        if (!sessionGet(convKey)) {
          sendConv(isBook ? CONV.book : CONV.contact, isBook ? 'book' : 'contact');
          sessionSet(convKey);
        }
      }
      document.addEventListener('click', function (e) {
        var a = e.target.closest('a[href^="mailto:"], a[href^="tel:"]');
        if (!a) return;
        var isMail = a.getAttribute('href').indexOf('mailto:') === 0;
        sendConv(isMail ? CONV.email : CONV.phone, isMail ? 'email' : 'phone');
      });
    } catch (err) { /* conversions must never break the modals */ }

  })();

  } catch(e) { console.error(e); }
})();
})();
